// Live character counter for the cart order note (quick cart and cart page).
// The 150-character limit itself is enforced by the textarea's maxlength.
// Listens on the document so it keeps working after the quick cart re-renders.
(function () {
  function update(input) {
    var wrapper = input.parentElement;
    if (!wrapper) return;

    var counter = wrapper.querySelector("[data-cart-note-counter]");
    if (!counter) return;

    var count = counter.querySelector("[data-cart-note-count]");
    var max = Number(counter.dataset.cartNoteMax || input.maxLength || 0);
    var length = input.value.length;

    if (count) count.textContent = length;
    if (max > 0) counter.classList.toggle("is-near-limit", length / max >= 0.9);
  }

  document.addEventListener("input", function (event) {
    var input = event.target.closest && event.target.closest("[data-cart-note-input]");
    if (input) update(input);
  });
})();
